import axios from 'axios'

const handleMap = (arr, map) => {
    arr.forEach(item => {
        map[item.orgId] = item.orgName
        if (item.childs) handleMap(item.childs, map)
    })
}

const state = {
    orgTree: [],
    orgMap: {},
    orgTreeProps: { children: 'childs', label: 'orgName', value: 'orgId' }
}

const mutations = {
    orgTree (state, tree) {
        state.orgTree = tree
    },
    orgMap (state, map) {
        state.orgMap = map
    }
}

const actions = {
    async getOrgTree (content) {
        const { data } = await axios.get(`/api/orgs/tree`).catch(error => { console.error('获取机构树异常',error.response) })
        if (data.status != 'yes') return console.error(`获取机构树异常`)
        const arr = [ data.data ] || []
        const map = {}
        handleMap(arr, map)
        content.commit('orgTree', arr)
        content.commit('orgMap', map)
    }
}

export const org = {
    state,
    mutations,
    actions
}
